import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IAccessories } from '@common-modules/product-catalogue';
import { mapAccessories } from '../../helpers/accessory';
import { updateAccessories } from '../../helpers/productDetails';
import { Accessory } from '../../types/accessory.types';
import { getUIAMEnabledWithToken } from '../../selectors';
import { AppState, KeyValue } from '../../types/common.types';
import { StockAvailability } from '../../types/product.types';

export const useAccessories = ({
  recommendedAccessories = [],
  accessories = [],
  stockAvailability
}: {
  recommendedAccessories: string[];
  accessories: Accessory[];
  stockAvailability: StockAvailability[];
}) => {
  const [formattedAccessories, setFormattedAccessories] = useState<
    IAccessories[] | undefined
  >();

  const { selectedAccessories } = useSelector<AppState, KeyValue>(state => {
    return {
      selectedAccessories: state.accessory?.selectedAccessories
    };
  });

  useEffect(() => {
    if (!stockAvailability) return;
    const setAccessories = async () => {
      let formattedAccessories = await mapAccessories(
        recommendedAccessories,
        accessories,
        stockAvailability
      );
      if (selectedAccessories?.length) {
        formattedAccessories = updateAccessories(
          formattedAccessories,
          selectedAccessories
        );
      }
      setFormattedAccessories(formattedAccessories);
    };
    setAccessories();
  }, [stockAvailability]);

  useEffect(() => {
    const updatedAccessories = updateAccessories(
      formattedAccessories,
      selectedAccessories
    );
    if (updatedAccessories) {
      setFormattedAccessories(updatedAccessories);
    }
  }, [selectedAccessories]);

  return {
    formattedAccessories,
    selectedAccessories
  };
};
